import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { PageHeader } from '../components/PageHeader';
import { useAuth } from '../contexts/AuthContext';
import { Award } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function PointsPage() {
    const { token, profile } = useAuth();
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchTransactions();
    }, [token]);

    const fetchTransactions = async () => {
        try {
            const response = await axios.get(`${API}/member/transactions`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setTransactions(response.data);
        } catch (error) {
            console.error('Error fetching transactions:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="page-container" data-testid="points-page">
            <PageHeader title="Points History" showBack />
            
            <div className="px-4 py-4">
                {/* Points Balance */}
                <div className="card-base bg-primary text-white mb-6" data-testid="points-balance">
                    <div className="text-center">
                        <Award className="w-12 h-12 mx-auto mb-2" />
                        <p className="text-white/80 text-sm">Your Points Balance</p>
                        <p className="text-4xl font-bold">{profile?.points_balance?.toLocaleString() || 0}</p>
                    </div>
                </div>

                {/* How points work */}
                <div className="card-base bg-primary/5 mb-6">
                    <h3 className="font-bold text-foreground mb-2">How points work</h3>
                    <p className="text-muted-foreground">
                        Earn 2 points for every £1 spent at Burston (after discounts). 
                        Show your membership card at checkout to collect points.
                    </p>
                </div>

                {/* Transaction History */}
                <h2 className="text-lg font-bold text-foreground mb-4">Transaction History</h2>
                
                {loading ? (
                    <div className="flex justify-center py-12">
                        <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin" />
                    </div>
                ) : transactions.length === 0 ? (
                    <div className="card-base text-center py-8">
                        <Award className="w-12 h-12 text-muted-foreground mx-auto mb-3" />
                        <p className="text-muted-foreground">No transactions yet</p>
                        <p className="text-sm text-muted-foreground mt-1">Start earning points on your next visit!</p>
                    </div>
                ) : (
                    <div className="card-base divide-y divide-primary/10" data-testid="transactions-list">
                        {transactions.map((tx) => (
                            <div key={tx.id} className="py-4 first:pt-0 last:pb-0">
                                <div className="flex justify-between items-start">
                                    <div>
                                        <p className="font-bold text-foreground">{tx.description}</p>
                                        <p className="text-sm text-muted-foreground">
                                            {new Date(tx.created_at).toLocaleDateString('en-GB', {
                                                weekday: 'long',
                                                day: 'numeric',
                                                month: 'long',
                                                year: 'numeric'
                                            })}
                                        </p>
                                    </div>
                                    <span className={`text-lg font-bold ${
                                        tx.transaction_type === 'earned' ? 'text-primary' : 'text-accent'
                                    }`}>
                                        {tx.transaction_type === 'earned' ? '+' : '-'}{tx.points}
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

export default PointsPage;
